// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark .theme-store-header-menu button.secondary {
  background: var(--black1);
}

.theme-store-header {
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1280px;
  margin: 0 auto;
  height: 56px;
  flex: 0 0 56px;
}
.theme-store-header-container {
  height: 56px;
  flex: 0 0 56px;
  border-bottom: 0;
  width: 100%;
  z-index: 13;
  position: relative;
  background: var(--white);
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);
  flex-direction: column;
}
@media (max-width: 768px) {
  .theme-store-header-container {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--black2);
    box-shadow: none;
    height: auto;
    flex: 0 0 auto;
  }
}
.theme-store-header-close {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  border-right: 1px solid var(--black1);
}
.theme-store-header-logo {
  width: 240px;
  height: 100%;
  cursor: pointer;
  background: var(--white);
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 2.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
}
@media (max-width: 768px) {
  .theme-store-header-logo {
    font-size: 16px;
    line-height: 24px;
    padding-left: 1rem;
  }
}
.theme-store-header-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 0 1rem 0 1rem;
}
.theme-store-header-menu {
  display: flex;
  align-items: center;
  transition: all 0.15s ease;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/store/header/style.scss"],"names":[],"mappings":"AAEI;EACE,yBAAA;AADN;;AAOA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AAJF;AAME;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,gDAAA;EACA,sBAAA;AAJJ;AAMI;EAXF;IAYI,aAAA;IACA,sBAAA;IACA,sCAAA;IACA,gBAAA;IACA,YAAA;IACA,cAAA;EAHJ;AACF;AAME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qCAAA;AAJJ;AAOE;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AANJ;AAQI;EAjBF;IAkBI,eAAA;IACA,iBAAA;IACA,kBAAA;EALJ;AACF;AAQE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AAPJ","sourcesContent":[".dark .theme-store-header {\n  &-menu {\n    button.secondary {\n      background: var(--black1);\n    }\n  }\n}\n\n\n.theme-store-header {\n  width: 100%;\n  display: flex;\n  position: relative;\n  max-width: 1280px;\n  margin: 0 auto;\n  height: 56px;\n  flex: 0 0 56px;\n\n  &-container {\n    height: 56px;\n    flex: 0 0 56px;\n    border-bottom: 0;\n    width: 100%;\n    z-index: 13;\n    position: relative;\n    background: var(--white);\n    box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08);\n    flex-direction: column;\n\n    @media (max-width: 768px) {\n      display: flex;\n      flex-direction: column;\n      border-bottom: 1px solid var(--black2);\n      box-shadow: none;\n      height: auto;\n      flex: 0 0 auto;\n    }\n  }\n\n  &-close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 1rem;\n    border-right: 1px solid var(--black1);\n  }\n\n  &-logo {\n    width: 240px;\n    height: 100%;\n    cursor: pointer;\n    background: var(--white);\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding-left: 2.5rem;\n\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n\n    @media (max-width: 768px) {\n      font-size: 16px;\n      line-height: 24px;\n      padding-left: 1rem;\n    }\n  }\n\n  &-buttons {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    padding: 0 1rem 0 1rem;\n  }\n\n  &-menu {\n    display: flex;\n    align-items: center;\n    transition: all .15s ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
